"use client";
import * as React from "react";
import { useEffect } from "react";

interface ThemerProps {
  overrideTheme?: Partial<Theme>;
  children: any;
}

import type { Theme } from "./types";

function Themer(props: ThemerProps) {
  useEffect(() => {
    Object.entries({
      ...props.overrideTheme,
    }).forEach(([cssVar, value]) => {
      document.documentElement.style.setProperty(cssVar, value);
    });
  }, [props.overrideTheme]);

  return <div id="__themer">{props.children}</div>;
}

export default Themer;
